<ziro-fieldset-header [legend]="'tkey;shared.dnWizard.dnDetails.dnExtensionDetails.enterprise_alternate_number.label'">
  <ziro-text fieldId="enterpriseNumberMask"></ziro-text>
  <ziro-checkbox fieldId="enterpriseAddToLocalRoutePartition"></ziro-checkbox>
  <ziro-select fieldId="enterpriseRoutePartition"></ziro-select>
  <ziro-checkbox fieldId="enterpriseUrgent"></ziro-checkbox>
  <ziro-checkbox fieldId="enterpriseAdvertiseGloballyViaIls"></ziro-checkbox>
</ziro-fieldset-header>

<ziro-fieldset-header [legend]="'tkey;shared.dnWizard.dnDetails.dnExtensionDetails.e164_alternate_number.label'">
  <ziro-text fieldId="e164NumberMask"></ziro-text>
  <ziro-checkbox fieldId="e164AddToLocalRoutePartition"></ziro-checkbox>
  <ziro-select fieldId="e164RoutePartition"></ziro-select>
  <ziro-checkbox fieldId="e164Urgent"></ziro-checkbox>
  <ziro-checkbox fieldId="e164AdvertiseGloballyViaIls"></ziro-checkbox>
</ziro-fieldset-header>

<ziro-fieldset-header [legend]="'tkey;shared.dnWizard.dnDetails.dnExtensionDetails.pstn_failover.label'">
  <ziro-select fieldId="pstnFailover"></ziro-select>
</ziro-fieldset-header>
